// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6109":"28e8e4a6","7711":"d345990a","7947":"d345990a","8277":"d345990a"}[chunkId] + ".chunk.css";
};